$(document).ready(function () {
    var colapsed = true;
    var colapsedCountItems = 2;
    var orderFileUploadShowMoreButtonText = $("#orderFileUploadShowMoreButtonText").val();
    var orderFileUploadShowLessButtonText = $("#orderFileUploadShowLessButtonText").val();

    $("#Files .Order").each(function (index, item) {
        if (index >= colapsedCountItems) {
            $(item).hide();
        }
    });

    $("#btnCollapseFileHints").click(function () {
        if (!colapsed) {
            $("#Files .Order").each(function (index, item) {
                if (index >= colapsedCountItems) {
                    $(item).hide();
                }
            });

            $("#btnCollapseFileHints").html(orderFileUploadShowMoreButtonText);
            $("#btnCollapseFileHints").removeClass("Less");
        } else {
            $("#Files .Order").each(function (index, item) {
                $(item).show();
            });

            $("#btnCollapseFileHints").html(orderFileUploadShowLessButtonText);
            $("#btnCollapseFileHints").addClass("Less");
        }
        colapsed = !colapsed;
    });
});